import React from "react";
import FlightCheckerBase from "./FlightCheckerBase";

export default function FlightCheckerT3() {
  return (
    <FlightCheckerBase
      terminal="3"
      defaultFlight="EK006"
      title="Heathrow Terminal 3 Flight Checker | Live T3 Flight Status, Queues, Gate & Reliability"
      metaDescription="Check Heathrow Terminal 3 flights by number with live T3 flight status, arrivals/departures, gate, check-in zone, immigration or security queue times and recent reliability context."
      metaKeywords="Heathrow Terminal 3 flight checker, Heathrow T3 flight status, Heathrow Terminal 3 arrivals, Heathrow Terminal 3 departures, Heathrow T3 gate, Heathrow T3 check-in zone, T3 immigration wait time, T3 security wait, Heathrow T3 reliability"
      canonical="https://www.cheapcabgrab.com/terminal-3-flight-checker"
      ogTitle="Heathrow Terminal 3 Flight Checker | Live T3 Status, Queues & Gate"
      ogDescription="Check Heathrow Terminal 3 flights for live status, arrivals or departures, gate, check-in zone, queue times and flight reliability."
      schemaName="Heathrow Terminal 3 Flight Checker"
      breadcrumbName="Terminal 3 Flight Checker"
      headerTitle="Heathrow Terminal 3 Flight Checker"
      headerIntro="Check Heathrow Terminal 3 arrivals and departures with terminal-specific queue times, gate details and reliability context."
      headerNote="Choose the exact Heathrow Terminal 3 arrival or departure time. Today, recent past flights and the next few days are included."
      inputPlaceholder="e.g. EK006"
      emptyInputMessage="Please enter a Terminal 3 flight number (e.g. EK006)."
      notFoundMessage="Flight not found at Heathrow Terminal 3 for the selected time. Please choose another listed Terminal 3 flight."
      resultHeading="Heathrow Terminal 3 Flight Details"
      pickupLabel="Calculate Terminal 3 pickup window →"
      faqTitle="Terminal 3 FAQs"
      faqItems={[
        { question: "How busy is Heathrow Terminal 3 security today?", answer: "Terminal 3 can be busy mid-morning and late evening due to long-haul banks; allow extra buffer then." },
        { question: "Is Terminal 3 faster than Terminal 5?", answer: "Often yes, but long-haul arrivals can still slow immigration." },
        { question: "Does Terminal 3 have eGates?", answer: "Yes, eGates are available for eligible passports at Terminal 3." },
        { question: "How long does it take to exit Terminal 3 after landing?", answer: "Typically 40–75 minutes depending on passport type and baggage." },
        { question: "Where should drivers wait for Terminal 3 pickups?", answer: "Wait nearby and only enter Short Stay once the passenger confirms they are landside." },
        { question: "Does Terminal 3 have long walking distances?", answer: "Moderate; most gates are centrally located and shorter than Terminal 5’s B and C satellites." },
      ]}
    />
  );
}
